import React, { lazy, Suspense } from 'react'
import styled from '@emotion/styled'
import { LoyaltyCardType, LoyaltyRewardType, StoreType } from './types'
import Spin from 'antd/lib/spin'
import { StyledDrawer, wideOrderDrawerStyles } from 'components/Common'

interface LoyaltyDrawerProps {
  activeCard: LoyaltyCardType | null
  activeRewards: LoyaltyRewardType[]
  stores: StoreType[]
  visible: boolean
  onClose: () => void
  onDrawerClose: () => void
}

const LoyaltyCardForm = lazy(() => import('./LoyaltyCardForm'))

const LoyaltyDrawer = (props: LoyaltyDrawerProps) => {
  const { activeCard, activeRewards, onClose, onDrawerClose, stores, visible } =
    props

  return (
    <WideStyledDrawer
      onClose={onClose}
      open={visible}
      title='Loyalty Card Settings'
      destroyOnClose={true}
    >
      <Suspense fallback={<Spin />}>
        <LoyaltyCardForm
          activeCard={activeCard}
          activeRewards={activeRewards}
          stores={stores}
          onDrawerClose={onDrawerClose}
        />
      </Suspense>
    </WideStyledDrawer>
  )
}

const WideStyledDrawer = styled(StyledDrawer)`
  ${wideOrderDrawerStyles}
`

export default LoyaltyDrawer
